import React, { useEffect, useState } from "react"
import styled from "styled-components"
import CustomModal from "../components/CustomModal"
import ProductListCard from "../components/ProductListCard"
import { BiFilterAlt } from "react-icons/bi"
import Footer from "../components/Footer"
import { collection, getDocs, query, where } from "firebase/firestore"
import { db } from "../firebase-config"
import { useParams } from "react-router-dom"

const ProductListScreen = () => {
  const [productListArr, setProductListArr] = useState([])
  const [showModal, setShowModal] = useState(false)
  const [filterCategory, setFilterCategory] = useState('')
  const [filterPrice, setFilterPrice] = useState('')
  const { subcategory } = useParams()

  const fetchProducts = async () => {
    if (subcategory != 0) {
      let subcat = subcategory.split(":")
      try {
        const q = query(
          collection(db, "products"),
          where("productDetails.subCategory", "==", subcat[1])
        )
        const querySnapshot = await getDocs(q)

        setProductListArr(
          querySnapshot.docs.map(doc => ({ ...doc.data(), id: doc.id }))
        )
      } catch (error) {
        console.error(error)
      }
    } else {
      try {
        const q = query(collection(db, "products"))
        const querySnapshot = await getDocs(q)

        setProductListArr(
          querySnapshot.docs.map(doc => ({ ...doc.data(), id: doc.id }))
        )
        console.log(productListArr)
      } catch (error) {
        console.error(error)
      }
    }
  }


  const applyFilter = async () => {
    setShowModal(false)
     if(filterPrice === 'desc' && filterCategory === null){
      productListArr.sort((item, item2) => Number(item2.productDetails.discountedPrice) - Number(item.productDetails.discountedPrice))
     }else if(filterPrice === 'asc' && filterCategory === null){
      productListArr.sort((item, item2) => Number(item.productDetails.discountedPrice) - Number(item2.productDetails.discountedPrice))
     } else if (filterPrice === 'desc' && filterCategory) {
      console.log('desc choose')

        const q = query(collection(db, "products"),where("productDetails.category", "==", filterCategory))
        const querySnapshot = await getDocs(q)
        setProductListArr(querySnapshot.docs.map(doc => ({ ...doc.data(), id: doc.id })))
        productListArr.sort((item, item2) => Number(item2.productDetails.discountedPrice) - Number(item.productDetails.discountedPrice))
     }else if (filterPrice === 'asc' && filterCategory){
       console.log('asc choose')
      const q = query(collection(db, "products"),where("productDetails.category", "==", filterCategory))
      const querySnapshot = await getDocs(q)
      setProductListArr(querySnapshot.docs.map(doc => ({ ...doc.data(), id: doc.id })))
      productListArr.sort((item, item2) => Number(item.productDetails.discountedPrice) - Number(item2.productDetails.discountedPrice))
     }else {
       return null
     }

     

  }


  const resetFilter = () => {
    setFilterCategory('')
    setFilterPrice('')
    fetchProducts()
  }

  const ModalView = (
    <ModalWrap>
      <label htmlFor="price">Filter By Price</label>

      <select name="Price" id="price" value={filterPrice} onChange={(e) => setFilterPrice(e.target.value)}>
        <option value="asc">Low to High</option>
        <option value="desc">High to Low</option>
      </select>
      <span>Filter by category</span>

      <select name="Category" value={filterCategory}  id="category" onChange={(e) => setFilterCategory(e.target.value)}>
        <option value={null} defaultValue>Choose</option>
        <option value="games">Games</option>
        <option value="others" >Others</option>
        <option value="cosmetics">Cosmetics</option>
        <option value="hardware" >Hardware</option>
      </select>

      <div className="applybtn_cont">
        <button onClick={resetFilter} className="applybtn">
          Reset
        </button>
        <button onClick={applyFilter} className="applybtn">
          Apply
        </button>
      </div>
    </ModalWrap>
  )

  useEffect(() => {
    fetchProducts()
  }, [subcategory])

  return (
    <>

      {showModal && (
        <CustomModal handleOnClick={() => setShowModal(false)}>
          {ModalView}
        </CustomModal>
      )}
      <ListWrapper>
        <ProductOption>
          <span className="productTitle">Products</span>
          <div className="addProductBtn">
            <button onClick={() => setShowModal(!showModal)}>
              <BiFilterAlt size={20}  color={"white"} /> <span style={{marginRight: '0.5rem', color: filterCategory !== 'Choose' && '#dc1d13'}}>Filter</span>
            </button>
          </div>
        </ProductOption>
        <ProductListCont>
          {productListArr.map((item, index) => {
            return (
              <ProductListCard
                key={index}
                linkTo={`/productdetail/:${item.id}`}
                productName={item.productDetails?.productName}
                sellerName={item.sellerName}
                productImage={item.productPhoto}
                productPrice={`${item.productDetails?.currency} ${item.productDetails?.originalPrice}`}
                discountPrice={`${item.productDetails?.currency} ${item.productDetails?.discountedPrice}`}
              />
            )
          })}
        </ProductListCont>
      </ListWrapper>
      <Footer />
    </>
  )
}

export default ProductListScreen

const ListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`
const ProductOption = styled.div`
  display: flex;
  width: 82%;
  justify-content: space-between;
  align-items: center;
  margin: 2rem 0;
  .productTitle {
    font-size: 2rem;
    font-family: Montserrat;
    font-weight: 600;
    letter-spacing: 2px;
    color: ${({ theme }) => theme.accent};

    @media screen and (max-width: 768px) {
      font-size: 1rem;
    }
  }
  .addProductBtn {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .addProductBtn button {
    display: flex;
    align-items: center;
    background: none;
    border: none;
    color: ${({ theme }) => theme.text};
    font-size: 1.2rem;
    font-family: Montserrat;
    font-weight: 600;
    letter-spacing: 2px;
    cursor: pointer;

    @media screen and (max-width: 768px) {
      font-size: 0.8rem;
    }
  }

  @media screen and (max-width: 768px) {
    width: 90%;
    justify-content: space-between;
  }
`
const ProductListCont = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  width: 90%;
  @media screen and (max-width: 768px) {
    width: 100%;
    justify-content: space-between;
  }
`
const ModalWrap = styled.div`
  display: flex;
  flex-direction: column;

  label, span {
    font-size: 0.8rem;
    color: ${({theme}) => theme.text};

  }

  select {
    margin-bottom: 0.5rem;
  }

  #price {
    border: none;
    outline: none;
    :focus {
      outline: none;
    }
  }

  .applybtn_cont {
    display: flex;
    align-items: center;
    padding: 0.5rem 0;
    justify-content: space-between;

    
  }

  .applybtn {
    border: none;
    outline: none;
    font-size: 0.8rem;
    background: ${({theme}) => theme.accent};
    width: fit-content;
    padding: 0.5rem 0.8rem;
    cursor: pointer;
    color: ${({theme}) => theme.text};
  }
`
